import { Component, PLATFORM_ID, inject } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { MovieDetails } from './components/movie-details/movie-details.component';
import { NormalNavbar } from '../../layout/normal-navbar/normal-navbar';
import { MovieCredits } from './components/movie-credits/movie-credits.component';
import { MovieRecommendations } from './components/movie-recommendations/movie-recommendations.component';
import { MovieFacts } from './components/movie-facts/movie-facts';
import { MovieAccounts } from './components/movie-accounts/movie-accounts.component';
import { MovieLinkedVideos } from './components/movie-linked-videos/movie-linked-videos';
import { YoutubePlayerService } from '../../core/services/youtube.service';
import { CommonModule } from '@angular/common';
import { Footer } from '../../layout/footer/footer.component';

@Component({
  selector: 'app-movie',
  imports: [
    CommonModule,
    MovieDetails,
    NormalNavbar,
    MovieCredits,
    MovieAccounts,
    MovieRecommendations,
    MovieFacts,
    MovieLinkedVideos,
    Footer
  ],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ],
  templateUrl: './movie.html',
  styleUrl: './movie.scss'
})

export class Movie {

  showPlayer: boolean = false;
  private readonly platformId = inject(PLATFORM_ID);

  constructor(
    private youtubeService: YoutubePlayerService
  ){}

  closeTrailer(): void {
    this.showPlayer = false;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = '';
    }
    
    // Destroy the YouTube player to stop playback
    if (this.youtubeService) {
      this.youtubeService.destroyPlayer();
    }
  }
}
